import { all, call, put, select, take, takeLatest } from "redux-saga/effects";
import { push } from "connected-react-router";
import * as profileService from "../../services/profile.service";
import * as actions from "../actions/profile.actions";
import { addContactAction, loadContactInvitesAction } from "../actions/contacts.actions";
import { getProfileId } from "../../services/profile.service";
import { toaster } from '../../components/Toasts/toaster';
import { cookies } from "../../utils/storage/CookieItem";

export function* loadProfileSaga(action) {
  try {
    yield put({ type: `${actions.LOAD_PROFILE}_PENDING` });
    const result = yield call(profileService.getProfile);
    yield put({ type: `${actions.LOAD_PROFILE}_SUCCEEDED`, payload: result });
    // yield put({ type: LOAD_CONTACTS, payload: { profileId: null } });
    yield put(loadContactInvitesAction());
  } catch (error) {
    yield put({ type: `${actions.LOAD_PROFILE}_FAILED`, payload: error });
  }
}

export function* searchProfilesSaga(action) {
  try {
    const { searchValue, slug } = action.payload;
    yield put({ type: `${actions.SEARCH_PROFILES}_PENDING` });
    const result = yield call(profileService.searchProfiles, searchValue, slug);
    yield put({ type: `${actions.SEARCH_PROFILES}_SUCCEEDED`, payload: result });
    if (result.data.length === 0) {
      yield call(toaster, 'noResultsFound');
    }
  } catch (error) {
    yield put({ type: `${actions.SEARCH_PROFILES}_FAILED`, payload: error });
  }
}

export function* updateProfileSaga(action) {
  try {
    const { slug, profileData } = action.payload;
    yield put({ type: `${actions.UPDATE_PROFILE}_PENDING` });
    const result = yield call(profileService.updateProfile, slug, profileData);
    yield put({ type: `${actions.UPDATE_PROFILE}_SUCCEEDED`, payload: result });
    yield call(toaster, 'profileSaved');
    yield put({ type: actions.LOAD_PROFILE });
  } catch (error) {
    yield put({ type: `${actions.UPDATE_PROFILE}_FAILED`, payload: error });
  }
}

export function* createProfileSaga(action) {
  try {
    const { slug, profileData } = action.payload;
    yield put({ type: `${actions.UPDATE_PROFILE}_PENDING` });
    const result = yield call(profileService.updateProfile, slug, profileData);
    yield put({ type: `${actions.UPDATE_PROFILE}_SUCCEEDED`, payload: result });
    yield put({ type: actions.LOAD_PROFILE });

    const preJoinContact = cookies.get("contact-pre-join");
    if (preJoinContact) {
      yield put(addContactAction(preJoinContact));
      cookies.remove("contact-pre-join");
    }

    yield put(push("/registration-success"));
  } catch (error) {
    yield put({ type: `${actions.UPDATE_PROFILE}_FAILED`, payload: error });
  }
}

export function* createRequiredProfile(action) {
  try {
    const { slug, profileData } = action.payload;
    yield put({ type: `${actions.UPDATE_PROFILE}_PENDING` });
    const result = yield call(profileService.updateProfile, slug, profileData);
    yield put({ type: `${actions.UPDATE_PROFILE}_SUCCEEDED`, payload: result });
    yield put({ type: actions.LOAD_PROFILE });
    yield take(`${actions.LOAD_PROFILE}_SUCCEEDED`);
    yield put(push("/create-profile"));
  } catch (error) {
    yield put({ type: `${actions.UPDATE_PROFILE}_FAILED`, payload: error });
  }
}

export function* confirmPhoneNumberSaga(action) {
  try {
    const { phoneNumber, verificationType } = action.payload.values;
    yield put({ type: `${actions.CONFIRM_PHONE_NUMBER}_PENDING` });
    const result = yield call(
      profileService.confirmPhoneNumber,
      { phoneNumber, verificationType }
    );
    yield put(
      {
        type: `${actions.CONFIRM_PHONE_NUMBER}_SUCCEEDED`,
        payload: {
          verificationCode: result.data.verificationCode,
          phoneNumber
        }
      }
    );

    yield put(push("/confirm-verification-code"));
  } catch (error) {
    yield put({ type: `${actions.CONFIRM_PHONE_NUMBER}_FAILED`, payload: error });
  }
}

export function* confirmVerificationCodeSaga(action) {
  try {
    const { userEnteredCode } = action.payload.values;
    yield put({ type: `${actions.CONFIRM_VERIFICATION_CODE}_PENDING` });
    const { verificationCode } = yield select(state => state.profile.registration);

    if (userEnteredCode == parseInt(verificationCode)) {
      yield put({ type: `${actions.CONFIRM_VERIFICATION_CODE}_SUCCEEDED` });
      const { slug } = yield select(state => state.profile.profile);
      const { phoneNumber } = yield select(state => state.profile.registration);
      const result = yield call(
        profileService.updateProfile,
        slug, {
          validated_phone_number: phoneNumber
        }
      );
      yield put({ type: actions.LOAD_PROFILE });
      yield take(`${actions.LOAD_PROFILE}_SUCCEEDED`);

      // check if email already present on profile
      const { email } = yield select(state => state.profile.profile);
      if (email) {
        yield put(push("/"));
      } else {
        yield put(push("/required-profile"));
      }
    }
  } catch (error) {
    yield put(push("/confirm-number"));
    yield put({
      type: `${actions.CONFIRM_VERIFICATION_CODE}_FAILED`,
      payload: error
    });
  }
}

export function* uploadProfileImageSaga(action) {
  try {
    const { image } = action.payload;
    var formData = new FormData();

    formData.append("image", image);
    formData.append("profile", getProfileId());

    yield put({ type: `${actions.UPLOAD_PROFILE_IMAGE}_PENDING` });
    const result = yield call(profileService.uploadProfileImage, formData);
    yield put({ type: `${actions.UPLOAD_PROFILE_IMAGE}_SUCCEEDED`, payload: result });
    yield put({ type: actions.LOAD_PROFILE });
  } catch (error) {
    yield put({ type: `${actions.UPLOAD_PROFILE_IMAGE}_FAILED`, payload: error });
  }
}

export function* sendFeedbackSaga(action) {
  try {
    const { values } = action.payload;
    yield put({ type: `${actions.SEND_FEEDBACK}_PENDING` });
    const result = yield call(profileService.sendFeedback, values);
    yield put({ type: `${actions.SEND_FEEDBACK}_SUCCEEDED`, payload: result });
  } catch (error) {
    yield put({ type: `${actions.SEND_FEEDBACK}_FAILED`, payload: error });
  }
}

export function* imageTooBigSaga() {
  try {
    yield call(toaster, 'fileSizeTooBig');
  } catch (error) {
    yield put({ type: `${actions.IMAGE_FILE_TOO_BIG}_FAILED`, payload: error });
  }
}

export function* watchLoadProfileSaga() {
  yield takeLatest(actions.LOAD_PROFILE, loadProfileSaga);
}

export function* watchSearchProfilesSaga() {
  yield takeLatest(actions.SEARCH_PROFILES, searchProfilesSaga);
}

export function* watchCreateProfileSaga() {
  yield takeLatest(actions.CREATE_PROFILE, createProfileSaga);
}

export function* watchConfirmPhoneNumberSaga() {
  yield takeLatest(actions.CONFIRM_PHONE_NUMBER, confirmPhoneNumberSaga);
}

export function* watchConfirmVerificationCodeSaga() {
  yield takeLatest(
    actions.CONFIRM_VERIFICATION_CODE,
    confirmVerificationCodeSaga
  );
}

export function* watchUpdateProfileSaga() {
  yield takeLatest(actions.UPDATE_PROFILE, updateProfileSaga);
}

export function* watchUploadProfileImageSaga() {
  yield takeLatest(actions.UPLOAD_PROFILE_IMAGE, uploadProfileImageSaga);
}

export function* watchcreateRequiredProfileSaga() {
  yield takeLatest(actions.CREATE_REQUIRED_PROFILE, createRequiredProfile);
}

export function* watchSendFeedbackSaga() {
  yield takeLatest(actions.SEND_FEEDBACK, sendFeedbackSaga);
}

export function* watchImageTooBigSaga() {
  yield takeLatest(actions.IMAGE_FILE_TOO_BIG, imageTooBigSaga);
}

export default function* profileSagas() {
  yield all([
    watchLoadProfileSaga(),
    watchSearchProfilesSaga(),
    watchCreateProfileSaga(),
    watchConfirmPhoneNumberSaga(),
    watchConfirmVerificationCodeSaga(),
    watchUpdateProfileSaga(),
    watchUploadProfileImageSaga(),
    watchcreateRequiredProfileSaga(),
    watchSendFeedbackSaga(),
    watchImageTooBigSaga(),
  ]);
}


// WEBPACK FOOTER //
// ./src/redux/sagas/profile.sagas.js